(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-image-full"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBannerZoom(root) {
      var frame = root.querySelector('[data-banner-frame]');
      if (!frame) return;

      var enabled = root.getAttribute('data-banner-zoom') === 'true';
      var startWidth = parseFloat(root.getAttribute('data-zoom-start-width'));
      var startRadius = parseFloat(root.getAttribute('data-zoom-start-radius'));
      var endRadius = parseFloat(root.getAttribute('data-zoom-end-radius'));
      if (isNaN(startWidth)) startWidth = 60;
      if (isNaN(startRadius)) startRadius = 24;
      if (isNaN(endRadius)) endRadius = 0;

      var startFactor = startWidth / 100;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var ticking = false;
      var lastProgress = null;

      function apply(progress) {
        if (lastProgress !== null && Math.abs(progress - lastProgress) < 0.0015) return;
        lastProgress = progress;

        var factor = startFactor + (1 - startFactor) * progress;
        var inset = (((1 - factor) / 2) * 100).toFixed(3) + '%';
        var radius = startRadius + (endRadius - startRadius) * progress;

        frame.style.top = inset;
        frame.style.right = inset;
        frame.style.bottom = inset;
        frame.style.left = inset;
        frame.style.borderRadius = radius.toFixed(1) + 'px';
      }

      /* Effet desactive : le cadre occupe tout de suite toute la place */
      if (!enabled || reduceMotion) {
        startFactor = 1;
        startRadius = endRadius;
        apply(1);
        return;
      }

      function update() {
        ticking = false;

        var vh = window.innerHeight || document.documentElement.clientHeight;
        var rect = root.getBoundingClientRect();

        /* 0 quand le haut de la banniere arrive en bas de l'ecran,
           1 quand la banniere est calee au centre de l'ecran (ou en haut si elle est plus haute) */
        var startY = vh;
        var endY = Math.max(0, (vh - rect.height) / 2);
        var span = startY - endY;
        var progress = span > 0 ? (startY - rect.top) / span : 1;
        if (progress < 0) progress = 0;
        if (progress > 1) progress = 1;

        apply(progress);
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    }

    document.querySelectorAll('.banner-full').forEach(initBannerZoom);

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('.banner-full');
      if (root) initBannerZoom(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-rhode"]) return;
  try {
    
  (function () {
    /* --- Zoom du grand logo au scroll --- */
    function initFooterScale(root) {
      var wrap = root.querySelector('[data-footer-scale]');
      var inner = wrap ? wrap.querySelector('[data-footer-scale-inner]') : null;
      if (!wrap || !inner) return;

      var startScale = parseFloat(wrap.getAttribute('data-start-scale')) || 1.4;
      var endScale = parseFloat(wrap.getAttribute('data-end-scale')) || 1.0;
      var ticking = false;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function update() {
        ticking = false;
        if (reduceMotion) {
          inner.style.transform = 'scale(' + endScale + ')';
          return;
        }

        var doc = document.documentElement;
        var vh = window.innerHeight || doc.clientHeight;
        var scrollY = window.pageYOffset || doc.scrollTop || 0;
        var rect = wrap.getBoundingClientRect();

        var elementTopAbs = rect.top + scrollY;
        var start = elementTopAbs - vh;
        var maxScroll = Math.max(doc.scrollHeight - vh, start + 1);

        var progress = (scrollY - start) / (maxScroll - start);
        if (progress < 0) progress = 0;
        if (progress > 1) progress = 1;

        var scale = startScale + (endScale - startScale) * progress;
        inner.style.transform = 'scale(' + scale.toFixed(4) + ')';
      }

      function onScroll() {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    }

    /* --- Liste deroulante maison --- */
    function normalize(str) {
      var s = String(str).toLowerCase();
      try {
        s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      } catch (e) {}
      return s;
    }

    function initCombo(combo) {
      var field = combo.querySelector('[data-combo-field]');
      var hidden = combo.querySelector('[data-combo-hidden]');
      var box = combo.querySelector('[data-combo-box]');
      var panel = combo.querySelector('[data-combo-panel]');
      var list = combo.querySelector('[data-combo-list]');
      var empty = combo.querySelector('[data-combo-empty]');
      var flag = combo.querySelector('[data-combo-flag]');
      var options = Array.prototype.slice.call(combo.querySelectorAll('[data-value]'));
      if (!field || !hidden || !panel || !options.length) return;

      var isOpen = false;
      var activeIndex = -1;

      function selected() {
        for (var i = 0; i < options.length; i++) {
          if (options[i].getAttribute('data-value') === hidden.value) return options[i];
        }
        return null;
      }

      function visibleOptions() {
        return options.filter(function (o) {
          return !o.hidden;
        });
      }

      function renderClosed() {
        var opt = selected();
        field.value = opt ? opt.getAttribute('data-label') : '';
        if (flag) {
          var src = opt && opt.getAttribute('data-flag');
          if (src) {
            flag.style.backgroundImage = 'url(' + src + ')';
            flag.hidden = false;
          } else {
            flag.hidden = true;
          }
        }
      }

      function setActive(index) {
        var vis = visibleOptions();
        options.forEach(function (o) {
          o.classList.remove('is-active');
        });
        activeIndex = index;
        if (index < 0 || index >= vis.length) return;
        var opt = vis[index];
        opt.classList.add('is-active');
        var top = opt.offsetTop;
        var bottom = top + opt.offsetHeight;
        if (top < list.scrollTop) list.scrollTop = top;
        else if (bottom > list.scrollTop + list.clientHeight) list.scrollTop = bottom - list.clientHeight;
      }

      function filter(query) {
        var q = normalize(query).trim();
        var count = 0;
        options.forEach(function (o) {
          var match = !q || normalize(o.getAttribute('data-label')).indexOf(q) !== -1;
          o.hidden = !match;
          if (match) count++;
        });
        if (empty) empty.hidden = count > 0;
        setActive(count ? 0 : -1);
      }

      function open() {
        if (isOpen) return;
        isOpen = true;
        combo.classList.add('is-open');
        panel.hidden = false;
        field.removeAttribute('readonly');
        field.value = '';
        if (flag) flag.hidden = true;
        field.setAttribute('aria-expanded', 'true');
        filter('');
        var opt = selected();
        if (opt && !opt.hidden) setActive(visibleOptions().indexOf(opt));
        field.focus({ preventScroll: true });
      }

      function close() {
        if (!isOpen) return;
        isOpen = false;
        combo.classList.remove('is-open');
        panel.hidden = true;
        field.setAttribute('readonly', 'readonly');
        field.setAttribute('aria-expanded', 'false');
        options.forEach(function (o) {
          o.hidden = false;
          o.classList.remove('is-active');
        });
        if (empty) empty.hidden = true;
        activeIndex = -1;
        renderClosed();
      }

      function choose(opt) {
        if (!opt) return;
        hidden.value = opt.getAttribute('data-value');
        options.forEach(function (o) {
          o.setAttribute('aria-selected', o === opt ? 'true' : 'false');
        });
        close();
        field.focus({ preventScroll: true });
      }

      if (box) {
        box.addEventListener('mousedown', function (e) {
          if (e.target === field && isOpen) return;
          e.preventDefault();
          if (isOpen) close();
          else open();
        });
      }

      field.addEventListener('input', function () {
        if (isOpen) filter(field.value);
      });

      field.addEventListener('keydown', function (e) {
        var vis;
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          if (!isOpen) {
            open();
            return;
          }
          vis = visibleOptions();
          if (!vis.length) return;
          var next = e.key === 'ArrowDown' ? activeIndex + 1 : activeIndex - 1;
          if (next < 0) next = vis.length - 1;
          if (next >= vis.length) next = 0;
          setActive(next);
          return;
        }

        if (e.key === 'Enter') {
          e.preventDefault();
          if (!isOpen) {
            open();
            return;
          }
          vis = visibleOptions();
          choose(vis[activeIndex] || vis[0]);
          return;
        }

        if (e.key === 'Escape' || e.key === 'Esc') {
          if (isOpen) {
            e.stopPropagation();
            close();
          }
        }
      });

      list.addEventListener('click', function (e) {
        var opt = e.target.closest ? e.target.closest('[data-value]') : null;
        if (opt) choose(opt);
      });

      list.addEventListener('mousemove', function (e) {
        var opt = e.target.closest ? e.target.closest('[data-value]') : null;
        if (!opt) return;
        var index = visibleOptions().indexOf(opt);
        if (index !== -1 && index !== activeIndex) setActive(index);
      });

      document.addEventListener('click', function (e) {
        if (isOpen && !combo.contains(e.target)) close();
      });

      renderClosed();

      return { close: close };
    }

    /* --- Popup pays de livraison --- */
    function initCountryModal(root) {
      var modal = root.querySelector('[data-country-modal]');
      if (!modal) return;

      var openers = root.querySelectorAll('[data-country-open]');
      var closers = modal.querySelectorAll('[data-country-close]');
      var combos = [];
      var lastFocused = null;
      var suggestionRequested = false;

      modal.querySelectorAll('[data-combo]').forEach(function (combo) {
        var api = initCombo(combo);
        if (api) combos.push(api);
      });

      function fillTokens(countryName, currencyCode) {
        modal.querySelectorAll('[data-token-template]').forEach(function (el) {
          var tpl = el.getAttribute('data-token-template');
          if (!tpl) return;
          el.textContent = tpl
            .replace(/\[pays\]/gi, countryName)
            .replace(/\[country\]/gi, countryName)
            .replace(/\[devise\]/gi, currencyCode)
            .replace(/\[currency\]/gi, currencyCode);
        });
      }

      /* Detection de la localisation du visiteur (une seule fois, a l'ouverture) */
      function loadSuggestion() {
        if (suggestionRequested || typeof window.fetch !== 'function') return;
        suggestionRequested = true;

        var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var url = base + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true';

        fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .then(function (data) {
            var detected = data && data.detected_values;
            if (!detected) return;

            var country = detected.country;
            var currency = detected.currency;
            var countryName = country && (country.name || country.handle);
            if (!countryName) return;

            var currencyCode = currency && (currency.handle || currency.iso_code || currency.name);
            if (!currencyCode && country && country.handle) {
              var opt = modal.querySelector('[data-value="' + country.handle + '"]');
              var match = opt && opt.getAttribute('data-label').match(/\(([^)]+)\)\s*$/);
              currencyCode = match ? match[1] : '';
            }

            fillTokens(countryName, currencyCode || '');
          })
          .catch(function () {});
      }

      function onKeydown(e) {
        if (e.key === 'Escape' || e.key === 'Esc') close();
      }

      function open() {
        lastFocused = document.activeElement;
        modal.hidden = false;
        loadSuggestion();
        requestAnimationFrame(function () {
          modal.classList.add('is-open');
        });
        document.documentElement.style.overflow = 'hidden';
        document.addEventListener('keydown', onKeydown);
        openers.forEach(function (btn) {
          btn.setAttribute('aria-expanded', 'true');
        });
      }

      function close() {
        combos.forEach(function (c) {
          c.close();
        });
        modal.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', onKeydown);
        openers.forEach(function (btn) {
          btn.setAttribute('aria-expanded', 'false');
        });
        window.setTimeout(function () {
          modal.hidden = true;
        }, 250);
        if (lastFocused && lastFocused.focus) lastFocused.focus({ preventScroll: true });
      }

      openers.forEach(function (btn) {
        btn.addEventListener('click', open);
      });
      closers.forEach(function (btn) {
        btn.addEventListener('click', close);
      });
    }

    function initFooterRhode(root) {
      initFooterScale(root);
      initCountryModal(root);
    }

    document.querySelectorAll('.footer-rhode').forEach(initFooterRhode);

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('.footer-rhode');
      if (root) initFooterRhode(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klean-product-swipe"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initProductSwipe(root) {
      var track = root.querySelector('[data-ps-track]');
      var prevBtn = root.querySelector('[data-ps-prev]');
      var nextBtn = root.querySelector('[data-ps-next]');
      var cursor = root.querySelector('[data-ps-cursor]');
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ps-card]'));
      if (!track || !cards.length) return;

      /* Mode grille : pas de fleches, pas de curseur glisser, pas de glisser-deposer */
      if (root.dataset.layout === 'grid') return;

      function step() {
        var card = cards[0];
        var style = getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || 0);
        return card.getBoundingClientRect().width + gap;
      }

      function updateArrows() {
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        if (prevBtn) prevBtn.disabled = track.scrollLeft <= 2;
        if (nextBtn) nextBtn.disabled = track.scrollLeft >= maxScroll;
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          updateArrows();
          ticking = false;
        });
      });
      window.addEventListener('resize', updateArrows);
      updateArrows();

      var isDown = false;
      var didDrag = false;

      var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (canHover && cursor) {
        cards.forEach(function (card) {
          card.addEventListener('pointerenter', function () {
            if (!isDown) cursor.classList.add('is-visible');
          });
          card.addEventListener('pointerleave', function () {
            cursor.classList.remove('is-visible');
          });
          card.addEventListener('pointermove', function (e) {
            var half = cursor.offsetWidth / 2;
            cursor.style.transform = 'translate(' + (e.clientX - half) + 'px,' + (e.clientY - half) + 'px)';
          });
        });
      }

      /* --- Glisser-deposer a la souris/stylet : passer d'une carte a l'autre en cliquant-glissant --- */
      var startX = 0;
      var startScrollLeft = 0;
      var activePointerId = null;
      var DRAG_THRESHOLD = 6;

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        if (e.target.closest('.product-swipe__buy-form, .product-swipe__buy-button')) return;
        isDown = true;
        didDrag = false;
        startX = e.clientX;
        startScrollLeft = track.scrollLeft;
        activePointerId = e.pointerId;
      });

      track.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var dx = e.clientX - startX;
        if (!didDrag && Math.abs(dx) > DRAG_THRESHOLD) {
          didDrag = true;
          track.classList.add('is-dragging');
          if (cursor) cursor.classList.remove('is-visible');
          /* La capture du pointeur n'est activee qu'une fois le glisser confirme :
             ainsi un simple clic (sans mouvement) n'est jamais intercepte et la
             carte ouvre normalement la fiche produit. */
          try { track.setPointerCapture(activePointerId); } catch (err) {}
        }
        if (didDrag) track.scrollLeft = startScrollLeft - dx;
      });

      function endDrag() {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
        if (activePointerId !== null) {
          try { track.releasePointerCapture(activePointerId); } catch (err) {}
          activePointerId = null;
        }
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointerleave', endDrag);
      track.addEventListener('pointercancel', endDrag);

      /* Empeche le clic (ouverture du produit) si le pointeur a servi a glisser le carrousel */
      track.addEventListener(
        'click',
        function (e) {
          if (didDrag) {
            e.preventDefault();
            e.stopPropagation();
            didDrag = false;
          }
        },
        true
      );
    }

    document.querySelectorAll('.product-swipe').forEach(initProductSwipe);

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('.product-swipe');
      if (root) initProductSwipe(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-swipe-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initProductSwipe(root) {
      var track = root.querySelector('[data-ps-track]');
      var prevBtn = root.querySelector('[data-ps-prev]');
      var nextBtn = root.querySelector('[data-ps-next]');
      var cursor = root.querySelector('[data-ps-cursor]');
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ps-card]'));
      if (!track || !cards.length) return;

      function step() {
        var card = cards[0];
        var style = getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || 0);
        return card.getBoundingClientRect().width + gap;
      }

      function updateArrows() {
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        if (prevBtn) prevBtn.disabled = track.scrollLeft <= 2;
        if (nextBtn) nextBtn.disabled = track.scrollLeft >= maxScroll;
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          updateArrows();
          ticking = false;
        });
      });
      window.addEventListener('resize', updateArrows);
      updateArrows();

      var isDown = false;
      var didDrag = false;

      var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (canHover && cursor) {
        cards.forEach(function (card) {
          card.addEventListener('pointerenter', function () {
            if (!isDown) cursor.classList.add('is-visible');
          });
          card.addEventListener('pointerleave', function () {
            cursor.classList.remove('is-visible');
          });
          card.addEventListener('pointermove', function (e) {
            var half = cursor.offsetWidth / 2;
            cursor.style.transform = 'translate(' + (e.clientX - half) + 'px,' + (e.clientY - half) + 'px)';
          });
        });
      }

      /* --- Glisser-deposer a la souris/stylet : passer d'une carte a l'autre en cliquant-glissant --- */
      var startX = 0;
      var startScrollLeft = 0;
      var DRAG_THRESHOLD = 6;

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        isDown = true;
        didDrag = false;
        startX = e.clientX;
        startScrollLeft = track.scrollLeft;
        track.classList.add('is-dragging');
        if (cursor) cursor.classList.remove('is-visible');
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
      });

      track.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > DRAG_THRESHOLD) didDrag = true;
        if (didDrag) track.scrollLeft = startScrollLeft - dx;
      });

      function endDrag() {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointerleave', endDrag);
      track.addEventListener('pointercancel', endDrag);

      /* Empeche le clic (ouverture du produit) si le pointeur a servi a glisser le carrousel */
      track.addEventListener(
        'click',
        function (e) {
          if (didDrag) {
            e.preventDefault();
            e.stopPropagation();
            didDrag = false;
          }
        },
        true
      );
    }

    document.querySelectorAll('.product-swipe').forEach(initProductSwipe);

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('.product-swipe');
      if (root) initProductSwipe(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
